var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"srcdoc":_vm.src,"title":"Html Preview","width":"630","height":"800"}})}
var staticRenderFns = []

export { render, staticRenderFns }